"use client";
import { jsx as r } from "react/jsx-runtime";
import { memo as m } from "react";
import { Box as e } from "../../blocks/base/Base.js";
import { s } from "../../Button.module-C3Ja-wjg.js";
const p = m(({ children: t, ...o }) => /* @__PURE__ */ r(e, { gap: 0, row: !0, className: s.set, ...o, children: t }));
p.displayName = "ButtonSet";
export {
  p as ButtonSet
};
